import { extractColumns } from 'shared/features/reportCard/components/table/utils';
import {
  CARD_CHART_MIN_WIDTH,
  CARD_LABEL_MIN_WIDTH,
  CARD_MAX_WIDTH,
  CARD_TABLE_MIN_WIDTH,
  CHART_CONTAINER_HEIGHT,
} from 'shared/features/reportCard/constants';

import { ReportGridItem } from '@/components/reports/types/report';

export const getReportCardWidths = (reportGridItem: ReportGridItem) => {
  const visualizationType = (reportGridItem as ReportGridItem).display?.visualization?.type;

  if (visualizationType === 'table') {
    const tableColumns =
      (reportGridItem.params.select || extractColumns(reportGridItem.baseQuery))?.length || 0;

    const hasMoreThan4Columns = tableColumns > 4;

    return {
      flex: 1,
      maxWidth: CARD_MAX_WIDTH,
      minWidth: hasMoreThan4Columns ? '100%' : CARD_TABLE_MIN_WIDTH,
    };
  }

  if (visualizationType === 'label') {
    return {
      flex: 1,
      maxWidth: CARD_MAX_WIDTH,
      minWidth: CARD_LABEL_MIN_WIDTH,
    };
  }

  return {
    flex: 1,
    maxWidth: CARD_MAX_WIDTH,
    minWidth: CARD_CHART_MIN_WIDTH,
  };
};

export const getReportCardHeight = (reportGridItem: ReportGridItem) => {
  if ((reportGridItem as ReportGridItem).display?.visualization?.type === 'table') {
    return '100%';
  }

  return CHART_CONTAINER_HEIGHT;
};
